var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _linearGradient34, _linearGradient35, _linearGradient36, _linearGradient37, _linearGradient38, _linearGradient39, _linearGradient40, _linearGradient41, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon5Star(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8f6fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#efdcfb"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 194.246,
    x2: 331.204,
    xlinkHref: "#lg1",
    y1: 217.364,
    y2: 354.322
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientTransform: "matrix(-1 0 0 -1 510 556.237)",
    gradientUnits: "userSpaceOnUse",
    x1: 211.441,
    x2: 309.637,
    xlinkHref: "#lg1",
    y1: 234.559,
    y2: 332.755
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efdcfb",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4856,
    stopColor: "#baaad6",
    stopOpacity: 0.486
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8679b2"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 271.261,
    x2: -59.406,
    xlinkHref: "#lg2",
    y1: 388.033,
    y2: 194.033
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 344.036,
    x2: 226.536,
    xlinkHref: "#lg2",
    y1: 333.057,
    y2: 67.557
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 470.363,
    x2: 382.363,
    xlinkHref: "#lg2",
    y1: 384.068,
    y2: 266.068
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 386.12,
    x2: 297.75,
    xlinkHref: "#lg2",
    y1: 465.38,
    y2: 377.01
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 284.812,
    x2: 106.192,
    xlinkHref: "#lg2",
    y1: 493.688,
    y2: 315.069
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#ffcd3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#ffad2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa325"
  }))), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg3",
    y1: 42.744,
    y2: 197.316
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbb27e",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff7044"
  }))), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 244.413,
    x2: 283.023,
    xlinkHref: "#lg4",
    y1: 137.75,
    y2: 40.347
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 332.263,
    x2: 190.107,
    xlinkHref: "#lg4",
    y1: 139.053,
    y2: 111.411
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 273.767,
    x2: 265.869,
    xlinkHref: "#lg4",
    y1: 198.696,
    y2: 59.831
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 228.456,
    x2: 290.978,
    xlinkHref: "#lg4",
    y1: 177.125,
    y2: 94.859
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 279.097,
    x2: 193.54,
    xlinkHref: "#lg4",
    y1: 164.244,
    y2: 125.414
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 87.911,
    x2: 87.911,
    xlinkHref: "#lg3",
    y1: 203.89,
    y2: 318.85
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 80.038,
    x2: 108.753,
    xlinkHref: "#lg4",
    y1: 274.549,
    y2: 202.108
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 145.374,
    x2: 39.649,
    xlinkHref: "#lg4",
    y1: 275.518,
    y2: 254.96
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 101.869,
    x2: 95.995,
    xlinkHref: "#lg4",
    y1: 319.876,
    y2: 216.598
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 68.17,
    x2: 114.67,
    xlinkHref: "#lg4",
    y1: 303.833,
    y2: 242.65
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 105.833,
    x2: 42.202,
    xlinkHref: "#lg4",
    y1: 294.253,
    y2: 265.375
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 171.504,
    x2: 171.504,
    xlinkHref: "#lg3",
    y1: 364.592,
    y2: 464.881
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 164.635,
    x2: 189.686,
    xlinkHref: "#lg4",
    y1: 426.234,
    y2: 363.037
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 221.633,
    x2: 129.4,
    xlinkHref: "#lg4",
    y1: 427.079,
    y2: 409.145
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 183.68,
    x2: 178.556,
    xlinkHref: "#lg4",
    y1: 465.776,
    y2: 375.679
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 154.282,
    x2: 194.847,
    xlinkHref: "#lg4",
    y1: 451.781,
    y2: 398.405
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 187.138,
    x2: 131.628,
    xlinkHref: "#lg4",
    y1: 443.423,
    y2: 418.23
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 338.496,
    x2: 338.496,
    xlinkHref: "#lg3",
    y1: 364.592,
    y2: 464.881
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 331.627,
    x2: 356.678,
    xlinkHref: "#lg4",
    y1: 426.234,
    y2: 363.037
  })), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 388.625,
    x2: 296.393,
    xlinkHref: "#lg4",
    y1: 427.079,
    y2: 409.145
  })), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 350.672,
    x2: 345.548,
    xlinkHref: "#lg4",
    y1: 465.776,
    y2: 375.679
  })), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 321.274,
    x2: 361.84,
    xlinkHref: "#lg4",
    y1: 451.781,
    y2: 398.405
  })), _linearGradient35 || (_linearGradient35 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 354.131,
    x2: 298.62,
    xlinkHref: "#lg4",
    y1: 443.423,
    y2: 418.23
  })), _linearGradient36 || (_linearGradient36 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 422.089,
    x2: 422.089,
    xlinkHref: "#lg3",
    y1: 203.89,
    y2: 318.85
  })), _linearGradient37 || (_linearGradient37 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 414.215,
    x2: 442.93,
    xlinkHref: "#lg4",
    y1: 274.549,
    y2: 202.108
  })), _linearGradient38 || (_linearGradient38 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 479.551,
    x2: 373.826,
    xlinkHref: "#lg4",
    y1: 275.518,
    y2: 254.96
  })), _linearGradient39 || (_linearGradient39 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 436.046,
    x2: 430.172,
    xlinkHref: "#lg4",
    y1: 319.876,
    y2: 216.598
  })), _linearGradient40 || (_linearGradient40 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: 402.347,
    x2: 448.847,
    xlinkHref: "#lg4",
    y1: 303.833,
    y2: 242.65
  })), _linearGradient41 || (_linearGradient41 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientUnits: "userSpaceOnUse",
    x1: 440.01,
    x2: 376.379,
    xlinkHref: "#lg4",
    y1: 294.253,
    y2: 265.375
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 278.118,
    fill: "url(#SVGID_1_)",
    r: 171.955
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 278.118,
    fill: "url(#SVGID_2_)",
    r: 123.289
  }), /*#__PURE__*/React.createElement("path", {
    d: "m351.886 420.19-182.105-182.105c-3.377-3.741-8.056-6.455-13.783-7.287l-13.079-1.901-36.84-36.799c-14.647 25.302-23.035 54.68-23.035 86.02 0 94.968 76.987 171.955 171.955 171.955 35.939.001 69.297-11.031 96.887-29.883z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m169.503 155.189c5.09 6.782 7.244 15.415 5.787 23.909l-4.752 27.704c-2.096 12.222 2.999 23.034 11.38 29.641l177.948 177.948c40.797-31.442 67.089-80.783 67.089-136.273 0-94.968-76.987-171.955-171.955-171.955-37.933 0-72.99 12.292-101.425 33.098z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m426.955 278.118c0-31.292-8.362-60.629-22.967-85.905-.989 1.26-1.879 2.649-2.636 4.183l-9.252 18.746c-3.368 6.825-9.879 11.556-17.411 12.65l-20.688 3.006c-18.967 2.756-26.541 26.065-12.816 39.443l17.353 17.353.075.073c3.706 5.021 5.265 11.378 4.192 17.634l-3.534 20.604c-1.455 8.483 1.749 16.052 7.25 21.02l29.538 29.539c19.468-27.87 30.896-61.771 30.896-98.346z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m267.92 422.48c-2.48-2.42-4.16-5.21-5.11-8.13-3.7-11.2 3.17-24.38 16.29-26.28l18.05-2.63c6.57-.95 12.25-5.08 15.19-11.03l8.07-16.36c6.6-13.38 24.34-14.81 33.34-4.29l32.64 32.63 1.97.29c-23.65 29.02-56.59 50.17-94.29 58.93-2.37.55-4.75 1.05-7.16 1.5-.43-3.4-1.73-6.65-3.79-9.43z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m294.07 445.61c-2.37.55-4.75 1.05-7.16 1.5-10.34 1.94-21.01 2.96-31.91 2.96-53.8 0-101.83-24.7-133.36-63.39l8.51-1.24c6.57-.95 12.25-5.08 15.19-11.03l8.07-16.36c6.61-13.38 24.35-14.81 33.35-4.29l32.63 32.63 11.51 1.68c5.21.75 9.43 3.29 12.4 6.77z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m282.882 32.668 12.44 25.205c4.529 9.177 13.284 15.537 23.411 17.009l27.816 4.042c25.503 3.706 35.686 35.046 17.232 53.034l-20.128 19.62c-7.328 7.143-10.672 17.435-8.942 27.521l4.752 27.703c4.356 25.4-22.303 44.769-45.114 32.777l-24.879-13.08c-9.058-4.762-19.879-4.762-28.937 0l-24.879 13.08c-22.81 11.992-49.47-7.377-45.114-32.777l4.752-27.703c1.73-10.086-1.614-20.378-8.942-27.521l-20.128-19.62c-18.454-17.988-8.271-49.328 17.232-53.034l27.816-4.042c10.127-1.472 18.882-7.832 23.411-17.009l12.44-25.205c11.402-23.109 44.356-23.109 55.761 0z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m202.417 70.983c-3.389 1.971-7.159 3.319-11.149 3.899l-27.816 4.042c-25.503 3.706-35.686 35.046-17.232 53.034l20.128 19.62c7.328 7.143 10.672 17.435 8.942 27.521l-4.752 27.704c-4.356 25.4 22.303 44.769 45.114 32.777l24.879-13.08c9.058-4.762 19.879-4.762 28.937 0l24.879 13.08c10.813 5.684 22.485 4.314 31.314-1.397z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m363.775 131.959-20.126 19.625c-4.581 4.462-7.595 10.135-8.793 16.229-.737 3.672-.803 7.49-.145 11.28l4.752 27.707c2.29 13.36-4.001 25.048-13.794 31.38-8.832 5.713-20.507 7.081-31.327 1.395l-24.877-13.07c-4.528-2.382-9.49-3.567-14.466-3.567v-80.449l.184.053-.079-.079-.104-.158v-126.966c11.083 0 22.179 5.778 27.878 17.335l12.439 25.193c2.738 5.568 7.042 10.096 12.268 13.123 3.383 1.974 7.16 3.317 11.149 3.896l27.812 4.041c14.742 2.132 24.364 13.505 26.286 26.193 1.421 9.267-1.264 19.244-9.057 26.839z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m175.148 167.818c.725 3.671.793 7.49.142 11.281l-4.752 27.704c-4.356 25.4 22.303 44.769 45.114 32.777l24.879-13.08c9.058-4.762 19.879-4.762 28.937 0l24.879 13.08c22.81 11.992 49.47-7.377 45.114-32.777l-4.751-27.704c-1.73-10.086 1.614-20.378 8.942-27.521l20.128-19.62c7.79-7.593 10.46-17.563 9.046-26.832z",
    fill: "url(#SVGID_11_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m334.71 179.099c-.65-3.791-.583-7.61.142-11.281l-197.678-62.692c-1.414 9.269 1.256 19.239 9.046 26.832l20.128 19.62c7.328 7.143 10.672 17.435 8.942 27.521l-4.752 27.704c-4.356 25.4 22.303 44.769 45.114 32.777l24.879-13.08c9.058-4.762 19.879-4.762 28.937 0l24.879 13.08c22.81 11.992 49.47-7.377 45.114-32.777z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m346.548 78.924-27.816-4.042c-3.984-.579-7.749-1.924-11.134-3.89l-123.136 167.274c8.814 5.643 20.429 6.97 31.19 1.313l24.879-13.08c9.058-4.762 19.879-4.762 28.937 0l24.879 13.08c22.81 11.992 49.47-7.377 45.114-32.777l-4.751-27.704c-1.73-10.086 1.614-20.378 8.942-27.521l20.128-19.62c18.454-17.987 8.271-49.327-17.232-53.033z",
    fill: "url(#SVGID_13_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m108.648 196.396 9.252 18.746c3.368 6.825 9.879 11.556 17.411 12.65l20.687 3.006c18.967 2.756 26.541 26.065 12.816 39.443l-14.97 14.592c-5.45 5.313-7.937 12.967-6.65 20.468l3.534 20.604c3.24 18.89-16.588 33.296-33.552 24.377l-18.503-9.728c-6.737-3.542-14.785-3.542-21.521 0l-18.503 9.728c-16.965 8.919-36.792-5.487-33.552-24.377l3.534-20.604c1.287-7.501-1.2-15.156-6.65-20.468l-14.97-14.592c-13.725-13.378-6.151-36.687 12.816-39.443l20.687-3.006c7.532-1.094 14.043-5.825 17.411-12.65l9.252-18.746c8.48-17.187 32.988-17.187 41.471 0z",
    fill: "url(#SVGID_14_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.804 224.893c-2.521 1.466-5.325 2.468-8.292 2.9l-20.687 3.006c-18.967 2.756-26.541 26.065-12.816 39.443l14.97 14.592c5.45 5.313 7.937 12.967 6.65 20.468l-3.534 20.604c-3.24 18.89 16.588 33.296 33.552 24.377l18.503-9.728c6.737-3.542 14.785-3.542 21.521 0l18.503 9.728c8.042 4.228 16.722 3.209 23.289-1.039z",
    fill: "url(#SVGID_15_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m168.811 270.242-14.968 14.596c-3.407 3.319-5.648 7.538-6.539 12.07-.548 2.731-.597 5.57-.108 8.389l3.534 20.607c1.703 9.936-2.976 18.629-10.259 23.338-6.569 4.249-15.252 5.267-23.299 1.038l-18.502-9.721c-3.368-1.772-7.058-2.653-10.759-2.653v-59.833l.137.039-.059-.059-.078-.118v-94.428c8.243 0 16.495 4.298 20.734 12.893l9.251 18.737c2.036 4.141 5.237 7.508 9.124 9.76 2.516 1.468 5.325 2.467 8.292 2.898l20.685 3.005c10.964 1.586 18.12 10.044 19.549 19.481 1.057 6.892-.94 14.313-6.735 19.961z",
    fill: "url(#SVGID_16_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m28.523 296.912c.539 2.73.589 5.571.106 8.39l-3.534 20.604c-3.24 18.89 16.588 33.296 33.552 24.377l18.503-9.728c6.737-3.542 14.785-3.542 21.521 0l18.503 9.728c16.965 8.919 36.792-5.487 33.552-24.377l-3.534-20.604c-1.287-7.501 1.2-15.156 6.65-20.468l14.97-14.592c5.794-5.647 7.78-13.062 6.728-19.956z",
    fill: "url(#SVGID_17_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m147.194 305.301c-.484-2.819-.434-5.66.106-8.39l-147.019-46.625c-1.052 6.894.934 14.308 6.728 19.956l14.97 14.592c5.45 5.313 7.937 12.967 6.65 20.468l-3.534 20.604c-3.24 18.89 16.588 33.296 33.552 24.377l18.503-9.728c6.737-3.542 14.785-3.542 21.521 0l18.503 9.728c16.965 8.919 36.792-5.487 33.552-24.377z",
    fill: "url(#SVGID_18_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m155.998 230.798-20.687-3.006c-2.963-.431-5.763-1.431-8.281-2.893l-91.58 124.407c6.555 4.197 15.193 5.184 23.197.976l18.503-9.728c6.737-3.542 14.785-3.542 21.521 0l18.503 9.728c16.965 8.919 36.792-5.487 33.552-24.377l-3.534-20.604c-1.287-7.501 1.2-15.156 6.65-20.468l14.97-14.592c13.727-13.378 6.153-36.686-12.814-39.443z",
    fill: "url(#SVGID_19_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m189.594 358.055 8.071 16.354c2.938 5.954 8.619 10.081 15.189 11.036l18.047 2.622c16.547 2.404 23.153 22.738 11.18 34.409l-13.059 12.73c-4.755 4.635-6.924 11.312-5.802 17.856l3.083 17.974c2.826 16.48-14.471 29.047-29.27 21.266l-16.142-8.486c-5.877-3.09-12.898-3.09-18.775 0l-16.142 8.486c-14.8 7.781-32.097-4.787-29.27-21.266l3.083-17.974c1.122-6.544-1.047-13.221-5.802-17.856l-13.059-12.73c-11.973-11.671-5.366-32.005 11.18-34.409l18.047-2.622c6.571-.955 12.251-5.082 15.189-11.036l8.071-16.354c7.4-14.994 28.781-14.994 36.181 0z",
    fill: "url(#SVGID_20_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m137.387 382.915c-2.199 1.279-4.645 2.153-7.234 2.53l-18.047 2.622c-16.547 2.404-23.153 22.738-11.18 34.409l13.059 12.73c4.755 4.635 6.924 11.312 5.802 17.856l-3.083 17.974c-2.826 16.48 14.471 29.047 29.27 21.266l16.142-8.486c5.877-3.09 12.898-3.09 18.775 0l16.142 8.486c7.015 3.688 14.588 2.799 20.317-.906z",
    fill: "url(#SVGID_21_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m242.079 422.476-13.058 12.733c-2.972 2.895-4.928 6.576-5.705 10.53-.478 2.383-.521 4.859-.094 7.319l3.083 17.977c1.486 8.668-2.596 16.252-8.95 20.36-5.73 3.706-13.305 4.595-20.325.905l-16.141-8.48c-2.938-1.546-6.157-2.314-9.386-2.314v-52.197l.12.034-.051-.051-.068-.103v-82.377c7.191 0 14.39 3.749 18.088 11.247l8.07 16.346c1.776 3.612 4.569 6.55 7.959 8.514 2.195 1.281 4.646 2.152 7.233 2.528l18.045 2.622c9.565 1.383 15.808 8.762 17.055 16.995.923 6.011-.82 12.485-5.875 17.412z",
    fill: "url(#SVGID_22_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m119.694 445.742c.471 2.382.514 4.86.092 7.319l-3.083 17.974c-2.826 16.48 14.471 29.047 29.27 21.266l16.142-8.486c5.877-3.09 12.898-3.09 18.775 0l16.142 8.486c14.8 7.781 32.097-4.787 29.27-21.266l-3.083-17.974c-1.122-6.544 1.047-13.221 5.802-17.856l13.059-12.73c5.054-4.927 6.787-11.395 5.869-17.409z",
    fill: "url(#SVGID_23_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m223.221 453.061c-.422-2.459-.378-4.938.092-7.319l-128.256-40.675c-.918 6.014.815 12.482 5.869 17.409l13.059 12.73c4.755 4.635 6.924 11.312 5.802 17.856l-3.083 17.974c-2.826 16.48 14.471 29.047 29.27 21.266l16.142-8.486c5.877-3.09 12.898-3.09 18.775 0l16.142 8.486c14.8 7.781 32.097-4.787 29.27-21.266z",
    fill: "url(#SVGID_24_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m230.901 388.066-18.047-2.622c-2.585-.376-5.028-1.248-7.224-2.524l-79.892 108.53c5.719 3.661 13.254 4.523 20.236.852l16.142-8.486c5.877-3.09 12.898-3.09 18.775 0l16.142 8.486c14.8 7.781 32.097-4.787 29.27-21.266l-3.083-17.974c-1.122-6.544 1.047-13.221 5.802-17.856l13.059-12.73c11.974-11.671 5.367-32.005-11.18-34.41z",
    fill: "url(#SVGID_25_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m356.586 358.055 8.071 16.354c2.938 5.954 8.619 10.081 15.189 11.036l18.047 2.622c16.547 2.404 23.153 22.738 11.18 34.409l-13.059 12.73c-4.755 4.635-6.924 11.312-5.802 17.856l3.083 17.974c2.826 16.48-14.471 29.047-29.27 21.266l-16.142-8.486c-5.877-3.09-12.898-3.09-18.775 0l-16.142 8.486c-14.8 7.781-32.097-4.787-29.27-21.266l3.083-17.974c1.122-6.544-1.047-13.221-5.802-17.856l-13.059-12.73c-11.973-11.671-5.366-32.005 11.18-34.409l18.047-2.622c6.571-.955 12.251-5.082 15.189-11.036l8.071-16.354c7.401-14.994 28.782-14.994 36.181 0z",
    fill: "url(#SVGID_26_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m304.38 382.915c-2.199 1.279-4.645 2.153-7.234 2.53l-18.047 2.622c-16.547 2.404-23.153 22.738-11.18 34.409l13.059 12.73c4.755 4.635 6.924 11.312 5.802 17.856l-3.083 17.974c-2.826 16.48 14.471 29.047 29.27 21.266l16.142-8.486c5.877-3.09 12.898-3.09 18.775 0l16.142 8.486c7.015 3.688 14.588 2.799 20.317-.906z",
    fill: "url(#SVGID_27_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m409.071 422.476-13.058 12.733c-2.972 2.895-4.928 6.576-5.705 10.53-.478 2.383-.521 4.859-.094 7.319l3.083 17.977c1.486 8.668-2.596 16.252-8.95 20.36-5.73 3.706-13.305 4.595-20.325.905l-16.141-8.48c-2.938-1.546-6.157-2.314-9.385-2.314v-52.197l.12.034-.051-.051-.068-.103v-82.377c7.191 0 14.39 3.749 18.088 11.247l8.07 16.346c1.776 3.612 4.569 6.55 7.959 8.514 2.195 1.281 4.646 2.152 7.233 2.528l18.045 2.622c9.565 1.383 15.808 8.762 17.055 16.995.922 6.011-.82 12.485-5.876 17.412z",
    fill: "url(#SVGID_28_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m286.687 445.742c.471 2.382.514 4.86.092 7.319l-3.083 17.974c-2.826 16.48 14.471 29.047 29.27 21.266l16.142-8.486c5.877-3.09 12.898-3.09 18.775 0l16.142 8.486c14.8 7.781 32.097-4.787 29.27-21.266l-3.083-17.974c-1.122-6.544 1.047-13.221 5.802-17.856l13.059-12.73c5.054-4.927 6.787-11.395 5.869-17.409z",
    fill: "url(#SVGID_29_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m390.213 453.061c-.422-2.459-.378-4.938.092-7.319l-128.256-40.676c-.918 6.014.815 12.482 5.869 17.409l13.059 12.73c4.755 4.635 6.924 11.312 5.802 17.856l-3.083 17.974c-2.826 16.48 14.471 29.047 29.27 21.266l16.142-8.486c5.877-3.09 12.898-3.09 18.775 0l16.142 8.486c14.8 7.781 32.097-4.787 29.27-21.266z",
    fill: "url(#SVGID_30_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m397.894 388.066-18.047-2.622c-2.585-.376-5.028-1.248-7.224-2.524l-79.893 108.53c5.719 3.661 13.254 4.523 20.236.852l16.142-8.486c5.877-3.09 12.898-3.09 18.775 0l16.142 8.486c14.8 7.781 32.097-4.787 29.27-21.266l-3.083-17.974c-1.122-6.544 1.047-13.221 5.802-17.856l13.059-12.73c11.974-11.671 5.367-32.005-11.179-34.41z",
    fill: "url(#SVGID_31_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m442.825 196.396 9.252 18.746c3.368 6.825 9.879 11.556 17.411 12.65l20.688 3.006c18.967 2.756 26.541 26.065 12.816 39.443l-14.97 14.592c-5.45 5.313-7.937 12.967-6.65 20.468l3.534 20.604c3.24 18.89-16.588 33.296-33.552 24.377l-18.503-9.728c-6.737-3.542-14.785-3.542-21.521 0l-18.503 9.728c-16.965 8.919-36.792-5.487-33.552-24.377l3.534-20.604c1.287-7.501-1.2-15.156-6.65-20.468l-14.97-14.592c-13.725-13.378-6.151-36.687 12.816-39.443l20.687-3.006c7.532-1.094 14.043-5.825 17.411-12.65l9.252-18.746c8.48-17.187 32.988-17.187 41.47 0z",
    fill: "url(#SVGID_32_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m382.981 224.893c-2.521 1.466-5.325 2.468-8.292 2.9l-20.687 3.006c-18.967 2.756-26.541 26.065-12.816 39.443l14.97 14.592c5.45 5.313 7.937 12.967 6.65 20.468l-3.534 20.604c-3.24 18.89 16.588 33.296 33.552 24.377l18.503-9.728c6.737-3.542 14.785-3.542 21.521 0l18.503 9.728c8.042 4.228 16.722 3.209 23.289-1.039z",
    fill: "url(#SVGID_33_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m502.988 270.242-14.968 14.596c-3.407 3.319-5.648 7.538-6.539 12.07-.548 2.731-.597 5.57-.108 8.389l3.534 20.607c1.703 9.936-2.976 18.629-10.259 23.338-6.569 4.249-15.252 5.267-23.299 1.038l-18.502-9.721c-3.368-1.772-7.058-2.653-10.759-2.653v-59.833l.137.039-.059-.059-.078-.118v-94.428c8.243 0 16.495 4.298 20.734 12.893l9.251 18.737c2.036 4.141 5.237 7.508 9.124 9.76 2.516 1.468 5.325 2.467 8.292 2.898l20.685 3.005c10.964 1.586 18.12 10.044 19.549 19.481 1.057 6.892-.94 14.313-6.735 19.961z",
    fill: "url(#SVGID_34_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m362.7 296.912c.539 2.73.589 5.571.106 8.39l-3.534 20.604c-3.24 18.89 16.588 33.296 33.552 24.377l18.503-9.728c6.737-3.542 14.785-3.542 21.521 0l18.503 9.728c16.965 8.919 36.792-5.487 33.552-24.377l-3.534-20.604c-1.287-7.501 1.2-15.156 6.65-20.468l14.97-14.592c5.794-5.647 7.78-13.062 6.728-19.956z",
    fill: "url(#SVGID_35_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m481.371 305.301c-.484-2.819-.434-5.66.106-8.39l-147.019-46.626c-1.052 6.894.934 14.308 6.728 19.956l14.97 14.592c5.45 5.313 7.937 12.967 6.65 20.468l-3.534 20.604c-3.24 18.89 16.588 33.296 33.552 24.377l18.503-9.728c6.737-3.542 14.785-3.542 21.521 0l18.503 9.728c16.965 8.919 36.792-5.487 33.552-24.377z",
    fill: "url(#SVGID_36_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m490.176 230.798-20.687-3.006c-2.963-.431-5.763-1.431-8.281-2.893l-91.579 124.407c6.555 4.197 15.193 5.184 23.197.976l18.503-9.728c6.737-3.542 14.785-3.542 21.521 0l18.503 9.728c16.965 8.919 36.792-5.487 33.552-24.377l-3.534-20.604c-1.287-7.501 1.2-15.156 6.65-20.468l14.97-14.592c13.725-13.378 6.152-36.686-12.815-39.443z",
    fill: "url(#SVGID_37_)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon5Star);
export default __webpack_public_path__ + "static/media/icon-5-star.4b2b152a15a4a1ebc7f70174496dc2ed.svg";
export { ForwardRef as ReactComponent };